import type { BaseKitchenSettingsItem, Task, Worksheet } from "@preppa/shared-types";

export type {
  ApiError,
  BusinessUnit,
  CbdStructureEntry,
  Worksheet,
  Task,
  Container,
  DayView,
  BaseKitchenSettingsItem,
} from "@preppa/shared-types";

export type TaskInputs = {
  itemCode: string;
  taskInputId: string;
  description: string;
  createDate: Date;
  modifyDate: Date;
  deleteDate: Date;
} & BaseKitchenSettingsItem;

export const TASK_STATUS = {
  TODO: "todo",
  IN_PROGRESS: "inProgress",
  DONE: "done",
} as const;

export type TaskStatus = typeof TASK_STATUS[keyof typeof TASK_STATUS];

export type ItemSalesPlan = {
  itemCode: string;
  plannedDayHour: string;
  buCode: string;
  buType: string;
  statusCode: string;
  forecastVol: number;
  plannedVol: number;
  producedVol: number;
  availableVol: number;
  uomCode: string;
  comment: string;
  createDate: Date;
  modifyDate: Date;
  deleteDate: Date;
}

type IngredientDetailMarketContainerConversion = {
  itemCode: string;
  buCode: string;
  buType: string;
  containerId: string;
  containerName: number;
  active: boolean;
  containerConversion: number;
  createDate: string;
  modifyDate: string;
  deleteDate: string;
}

export type PlanData = {
  itemCode: string;
  taskData: Task;
  worksheetData: Worksheet;
  displayContainerId: string;
  containerConversionDtos: IngredientDetailMarketContainerConversion[];
  itemSalesPlanDtos: ItemSalesPlan[];
  itemMarketDetailTaskInputDtos: TaskInputs[];
  dayPlanPrio: string;
  ppsiUrl: string;
  localName: string;
  commercialStock: string;
  itemComment: string;
}

export type PlanDataDay = {
  planDay: string;
  dayPlanDatas: PlanData[];
}

/**
 * The period a task card covers, both YYYYMMDDHH and both inclusive.
 * toHour doubles as the server-side key of the daily task and as the
 * itemSalesPlan row the write is mirrored onto, so it must be a real plan hour.
 */
export type TaskHourRange = {
  fromHour: string;
  toHour: string;
}

export type HourlyTaskCard = {
  hour: number;
  itemSalesPlan: ItemSalesPlan;
  parentPlanData: PlanData;
} & TaskHourRange;

export type DailyTaskCard = {
  itemSalesPlan: ItemSalesPlan;
  parentPlanData: PlanData;
  totalPlannedVol: number;
  totalForecastedVol: number;
} & TaskHourRange;

export type CustomTaskCard = {
  slotIndex: number;
  itemSalesPlan: ItemSalesPlan;
  parentPlanData: PlanData;
  totalPlannedVol: number;
  totalForecastedVol: number;
} & TaskHourRange;

export type Notification = {
  id: string;
  topic: string;
  entityId: string;
  entityName: string;
  buCode: string;
  timestamp: Date;
}

export type DeviceGroupDto = {
  groupId: string;
} & BaseKitchenSettingsItem;

export type NormalizedUnit = "G" | "KG" | "ML" | "L";

export type AutoUnitConfig = {
  label: string;
  conversionFactor: number;
}

export type ComplementaryAutoUnit = AutoUnitConfig & {
  autoUnitId: string;
}